import {
  Stack,
  Button,
  Box,
  ClickAwayListener,
  Divider,
  MenuItem,
  InputLabel,
  FormControl,
  Select,
  Typography,
} from "@mui/material";
import { toast } from "material-react-toastify";
import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useParams } from "react-router";
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit";
import { djangoHandleDataRequests } from "../../../../api";
import ShopWrapper from "../ShopWrapper";
import moment from "moment";
import { DateRange } from "react-date-range";
import { SecondaryButton } from "../../../../Utils/ButtonHelper";
import paginationFactory from "react-bootstrap-table2-paginator";
import { connect } from "react-redux";
import ReportsLoader from "../../../../Utils/ReportsLoader";
import { useTranslation } from "react-i18next";

const styles = {
  position: "absolute",
  top: 28,
  right: 0,
  left: 10,
  zIndex: 100,
  p: 1,
  width: "fit-content",
  bgcolor: "background.paper",
  borderRadius: "5px",
  boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
};

const OrderWiseSalesSummaryReportForParticularDay = ({ data }) => {
  const { t } = useTranslation();

  // getting the hotel currency
  const hotelCurrency = data?.accessControl?.hotel?.hotel_currency;
  const { ExportCSVButton } = CSVExport;
  const { SearchBar } = Search;

  const url = new URL(window.location.href);
  const hotelId = url.searchParams.get("hotelId");
  const { shopId } = useParams();

  // Getting the start date as well as the end date to load the data
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  // Date picker state
  const [open, setOpen] = useState(false);
  const handleClick = () => {
    setOpen((prev) => !prev);
  };
  const handleClickAway = () => {
    setOpen(false);
  };

  // Get All report data
  const [reportsData, setreportsData] = useState([]);
  const [copyreportsData, setCopyreportsData] = useState(null);
  // State for totals
  const [totals, setTotals] = useState({});

  useEffect(() => {
    getOrderWiseSalesSummaryReportForParticularDayData();
  }, []);

  // Calculate totals from report data
  const calculateTotals = (data) => {
    const totals = {
      order_no: "Total",
      my_amount: 0,
      total_discount: 0,
      service_charge: 0,
      net_sales: 0,
      cgst_amount: 0,
      sgst_amount: 0,
      total_sales: 0,
      settled_amount: 0,
      balance_amount: 0,
    };

    data.forEach((item) => {
      totals.my_amount += parseFloat(item.my_amount || 0);
      totals.total_discount += parseFloat(item.total_discount || 0);
      totals.service_charge += parseFloat(item.service_charge || 0);
      totals.net_sales += parseFloat(item.net_sales || 0);
      totals.cgst_amount += parseFloat(item.cgst_amount || 0);
      totals.sgst_amount += parseFloat(item.sgst_amount || 0);
      totals.total_sales += parseFloat(item.total_sales || 0);
      totals.settled_amount += parseFloat(item.settled_amount || 0);
      totals.balance_amount += parseFloat(item.balance_amount || 0);
    });

    // Format to 2 decimal places
    Object.keys(totals).forEach((key) => {
      if (key !== "order_no") {
        totals[key] = Number(totals[key]).toFixed(2);
      }
    });

    return totals;
  };

  // Process the data to show My amount as Net sales for complimentary orders
  const processReportData = (data) => {
    return data.map((item) => {
      const processed = { ...item };

      // If it's a complimentary order, set my_amount equal to net_sales
      if (processed.complimentary_order === "Yes") {
        processed.my_amount = processed.net_sales;
      }

      return processed;
    });
  };

  //Function to get report data
  const getOrderWiseSalesSummaryReportForParticularDayData = () => {
    setCopyreportsData(null);
    shopId &&
      djangoHandleDataRequests(
        `pos/OrderWiseSalesSummaryReportForParticularDay/?shop_id=${shopId}&start_date=${moment(
          dateRange[0].startDate
        ).format("YYYY-MM-DD 00:00:00")}&end_date=${moment(
          dateRange[0].endDate
        ).format("YYYY-MM-DD 23:59:59")}&hotel_id=${hotelId}`
      )
        .then((res) => {
          // Process the data for complimentary orders
          const processedData = processReportData(res);
          setreportsData(processedData);
          setCopyreportsData(
            processedData
              .filter((item) => item.payment_type.length > 0)
              .map((i) => i)
          );

          // Calculate totals
          const calculatedTotals = calculateTotals(processedData);
          setTotals(calculatedTotals);
        })
        .catch((err) =>
          toast.error(`${t("Error in getting data! Please try again later.")}`)
        );
  };

  // Columns
  const headerStyle = {
    fontSize: "12px",
    width: "150px",
    wordBreak: "break-all",
  };

  const columns = [
    {
      dataField: "order_no",
      text: `${t("Bill no.")}`,
      headerStyle: {
        fontSize: "12px",
        width: "150px",
        flexWrap: "wrap",
        wordBreak: "break-all",
      },
      footer: "Total",
    },
    {
      dataField: "custom_invoice_id",
      text: `${t("Invoice no.")}`,
      headerStyle: {
        fontSize: "12px",
        width: "150px",
        flexWrap: "wrap",
        wordBreak: "break-all",
      },
      footer: "",
      footerStyle: {
        fontWeight: "bold",
        backgroundColor: "#f0f0f0",
      },
    },
    {
      dataField: "date",
      text: `${t("Date")}`,
      headerStyle: {
        fontSize: "12px",
        width: "150px",
      },
      footer: "",
      footerStyle: { backgroundColor: "#f0f0f0" },
    },
    {
      dataField: "booking_id",
      text: `${t("Booking Id")}`,
      headerStyle: {
        fontSize: "12px",
        width: "180px",
      },
      footer: "",
      footerStyle: { backgroundColor: "#f0f0f0" },
    },
    {
      dataField: "room_id",
      text: "Room Id",
      headerStyle: {
        fontSize: "12px",
        width: "125px",
      },
      footer: "",
      footerStyle: { backgroundColor: "#f0f0f0" },
    },
    {
      dataField: "order_status",
      text: `${t("Order status")}`,
      headerStyle: {
        fontSize: "12px",
        width: "150px",
        wordBreak: "break-all",
      },
      footer: "",
      footerStyle: { backgroundColor: "#f0f0f0" },
    },
    {
      dataField: "my_amount",
      text: `${t(`My amount (${hotelCurrency})`)}`,
      headerStyle: {
        fontSize: "12px",
        width: "150px",
        flexWrap: "wrap",
        wordBreak: "break-all",
      },
      footer: (columnData) => totals.my_amount,
      footerStyle: {
        fontWeight: "bold",
        backgroundColor: "#f0f0f0",
      },
    },
    {
      dataField: "total_discount",
      text: `${t(`Total discount (${hotelCurrency})`)}`,
      headerStyle: {
        fontSize: "12px",
        width: "150px",
        flexWrap: "wrap",
        wordBreak: "break-all",
      },
      footer: (columnData) => totals.total_discount,
      footerStyle: {
        fontWeight: "bold",
        backgroundColor: "#f0f0f0",
      },
    },
    {
      dataField: "service_charge",
      text: `${t(`Service charge (${hotelCurrency})`)}`,
      headerStyle: {
        fontSize: "12px",
        width: "150px",
        flexWrap: "wrap",
        wordBreak: "break-all",
      },
      footer: (columnData) => totals.service_charge,
      footerStyle: {
        fontWeight: "bold",
        backgroundColor: "#f0f0f0",
      },
    },
    {
      dataField: "net_sales",
      text: `${t(`Net sales (${hotelCurrency})`)}`,
      headerStyle: {
        fontSize: "12px",
        width: "150px",
        flexWrap: "wrap",
        wordBreak: "break-all",
      },
      footer: (columnData) => totals.net_sales,
      footerStyle: {
        fontWeight: "bold",
        backgroundColor: "#f0f0f0",
      },
    },
    {
      dataField: "cgst_amount",
      text: `${t(`CGST amount (${hotelCurrency})`)}`,
      hidden: hotelCurrency?.toLowerCase() === "inr" ? false : true,
      headerStyle: {
        fontSize: "12px",
        width: "150px",
        flexWrap: "wrap",
        wordBreak: "break-all",
      },
      footer: (columnData) => totals.cgst_amount,
      footerStyle: {
        fontWeight: "bold",
        backgroundColor: "#f0f0f0",
      },
    },
    {
      dataField: "sgst_amount",
      text: `${
        localStorage.getItem("utgstStatus") === "ENABLED" ? "UTGST" : "SGST"
      } amount (${hotelCurrency})`,
      hidden: hotelCurrency?.toLowerCase() === "inr" ? false : true,
      dataType: "float",
      headerStyle: {
        fontSize: "12px",
        width: "150px",
        flexWrap: "wrap",
        wordBreak: "break-all",
      },
      footer: (columnData) => totals.sgst_amount,
      footerStyle: {
        fontWeight: "bold",
        backgroundColor: "#f0f0f0",
      },
    },
    {
      dataField: "tax_percentage",
      text: `${t("Tax %")}`,
      hidden: hotelCurrency?.toLowerCase() === "inr" ? false : true,
      dataType: "float",
      formatter: (cell) => {
        return Number(cell).toFixed(2);
      },
      headerStyle: {
        fontSize: "12px",
        width: "150px",
        flexWrap: "wrap",
        wordBreak: "break-all",
      },
      footer: "",
      footerStyle: { backgroundColor: "#f0f0f0" },
    },
    {
      dataField: "cgst_tax_perc",
      text: `${t("CGST tax %")}`,
      hidden: hotelCurrency?.toLowerCase() === "inr" ? false : true,
      dataType: "float",
      formatter: (cell) => {
        return Number(cell).toFixed(2);
      },
      headerStyle: {
        fontSize: "12px",
        width: "150px",
        flexWrap: "wrap",
        wordBreak: "break-all",
      },
      footer: "",
      footerStyle: { backgroundColor: "#f0f0f0" },
    },
    {
      dataField: "sgst_tax_perc",
      text: `${
        localStorage.getItem("utgstStatus") === "ENABLED" ? "UTGST" : "SGST"
      } tax %`,
      hidden: hotelCurrency?.toLowerCase() === "inr" ? false : true,
      dataType: "float",
      formatter: (cell) => {
        return Number(cell).toFixed(2);
      },
      headerStyle: {
        fontSize: "12px",
        width: "150px",
        flexWrap: "wrap",
        wordBreak: "break-all",
      },
      footer: "",
      footerStyle: { backgroundColor: "#f0f0f0" },
    },
    {
      dataField: "total_sales",
      text: `${t(`Total sales (${hotelCurrency})`)}`,
      headerStyle: {
        fontSize: "12px",
        width: "150px",
        flexWrap: "wrap",
        wordBreak: "break-all",
      },
      footer: (columnData) => totals.total_sales,
      footerStyle: {
        fontWeight: "bold",
        backgroundColor: "#f0f0f0",
      },
    },
    {
      dataField: "settled_amount",
      text: `${t(`Settled amount (${hotelCurrency})`)}`,
      headerStyle: {
        fontSize: "12px",
        width: "150px",
        flexWrap: "wrap",
        wordBreak: "break-all",
      },
      footer: (columnData) => totals.settled_amount,
      footerStyle: {
        fontWeight: "bold",
        backgroundColor: "#f0f0f0",
      },
    },
    {
      dataField: "balance_amount",
      text: `${t(`Balance amount (${hotelCurrency})`)}`,
      headerStyle: {
        fontSize: "12px",
        width: "150px",
        flexWrap: "wrap",
        wordBreak: "break-all",
      },
      footer: (columnData) => totals.balance_amount,
      footerStyle: {
        fontWeight: "bold",
        backgroundColor: "#f0f0f0",
      },
    },
    {
      dataField: "payment_type",
      text: `${t("Payment type")}`,
      headerStyle: {
        fontSize: "12px",
        width: "150px",
        wordBreak: "break-all",
      },
      footer: "",
      footerStyle: { backgroundColor: "#f0f0f0" },
    },
    {
      dataField: "complimentary_order",
      text: `${t("Complimentary order")}`,
      headerStyle: {
        fontSize: "12px",
        width: "150px",
      },
      footer: "",
      footerStyle: { backgroundColor: "#f0f0f0" },
    },
    {
      dataField: "comp_reason",
      text: `${t("Reason")}`,
      headerStyle: {
        fontSize: "12px",
        width: "150px",
        flexWrap: "wrap",
        wordBreak: "break-all",
      },
      footer: "",
      footerStyle: { backgroundColor: "#f0f0f0" },
    },
    {
      dataField: "remark",
      text: `${t("Remarks")}`,
      headerStyle: {
        fontSize: "12px",
        width: "150px",
        flexWrap: "wrap",
        wordBreak: "break-all",
      },
      footer: "",
      footerStyle: { backgroundColor: "#f0f0f0" },
    },
    {
      dataField: "staff_name",
      text: `${t("Staff name")}`,
      headerStyle: {
        fontSize: "12px",
        width: "150px",
        flexWrap: "wrap",
        wordBreak: "break-all",
      },
      footer: "",
      footerStyle: { backgroundColor: "#f0f0f0" },
    },
  ];

  return (
    <ShopWrapper
      backBtn={true}
      contentArea={
        <>
          <h1 className="mt-3 mb-3">{t("Order Wise Sales Summary Reports")}</h1>
          <Divider className="mt-2 mb-2" />
          {reportsData ? (
            <div className="App">
              <ToolkitProvider
                keyField="order_no"
                data={reportsData}
                columns={columns}
                exportCSV
                search
              >
                {(props) => (
                  <div>
                    <Stack
                      className="position-relative w-100 justify-content-between mt-4"
                      direction="row"
                    >
                      <Stack
                        className="position-relative"
                        spacing={2}
                        direction="row"
                      >
                        <SearchBar
                          {...props.searchProps}
                          style={{
                            marginTop: "auto",
                            marginBottom: "auto",
                            height: "40px",
                          }}
                        />
                        <Stack spacing={4} className="position-relative">
                          <ClickAwayListener onClickAway={handleClickAway}>
                            <Box sx={{ position: "relative" }}>
                              <button
                                onClick={handleClick}
                                className="border border-1 rounded p-2"
                                style={{
                                  backgroundColor: "transparent",
                                  height: "37.5px",
                                }}
                              >
                                {moment(dateRange[0].startDate).format(
                                  "DD MMM YYYY"
                                )}{" "}
                                {" to "}
                                {moment(dateRange[0].endDate).format(
                                  "DD MMM YYYY"
                                )}
                              </button>
                              {open ? (
                                <Box sx={styles}>
                                  <Stack spacing={3}>
                                    <DateRange
                                      editableDateInputs={true}
                                      onChange={(item) =>
                                        setDateRange([item.selection])
                                      }
                                      moveRangeOnFirstSelection={false}
                                      ranges={dateRange}
                                    />
                                    <Stack
                                      className="position-relative w-100 d-flex justify-content-between"
                                      direction="row"
                                    >
                                      <SecondaryButton
                                        text={t("Cancel")}
                                        onClick={() => setOpen(false)}
                                      />
                                      <Button
                                        variant="custom-button"
                                        onClick={() => {
                                          getOrderWiseSalesSummaryReportForParticularDayData();
                                          handleClickAway();
                                        }}
                                      >
                                        {t("Apply")}
                                      </Button>
                                    </Stack>
                                  </Stack>
                                </Box>
                              ) : null}
                            </Box>
                          </ClickAwayListener>
                        </Stack>
                      </Stack>
                      <ExportCSVButton
                        {...props.csvProps}
                        style={{
                          display: "block",
                          background: "black",
                          color: "white",
                          marginTop: -1.5,
                          marginBottom: "auto",
                          marginLeft: "auto",
                        }}
                      >
                        {t("Export CSV")}
                      </ExportCSVButton>
                    </Stack>
                    <Stack className="mt-4">
                      {columns.length > 0 && reportsData.length > 0 ? (
                        <BootstrapTable
                          pagination={paginationFactory({ sizePerPage: 10 })}
                          footerClasses="footer-class"
                          {...props.baseProps}
                        />
                      ) : (
                        <Typography
                          className="position-relative mt-8 text-align-center"
                          style={{
                            fontSize: "15px",
                            marginTop: "15px",
                            color: "grey",
                            textAlign: "center",
                          }}
                        >
                          {t("No data found!")}
                        </Typography>
                      )}
                    </Stack>
                  </div>
                )}
              </ToolkitProvider>
            </div>
          ) : (
            <ReportsLoader />
          )}
        </>
      }
    />
  );
};

function mapStateToProps(state) {
  return { data: state.auth.selectedHotel };
}
export default connect(mapStateToProps)(
  OrderWiseSalesSummaryReportForParticularDay
);
